import styled from 'styled-components';
import PlayIcon from '~/assets/icons/sm_play.svg';
import ImageIcon from '~/assets/icons/uploadImage.svg';
import VideoIcon from '~/assets/icons/uploadVideo.svg';
import PdfIcon from '~/assets/icons/uploadPdf.svg';
import PreviewIcon from '~/assets/icons/eye.svg';

export const PlayIconForButton = styled(PlayIcon)``;
export const UploadImageIcon = styled(ImageIcon)``;
export const UploadVideoIcon = styled(VideoIcon)``;
export const UploadPdfIcon = styled(PdfIcon)``;
export const EyeIcon = styled(PreviewIcon)``;
